var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1035 24.2073C6.9805 24.2073 1.99988 19.2266 1.99988 13.1036C1.99988 6.98063 6.9805 2 13.1035 2C19.2265 2 24.2071 6.98063 24.2071 13.1036C24.2071 19.2266 19.2265 24.2073 13.1035 24.2073ZM13.1035 4.16613C8.17488 4.16613 4.166 8.175 4.166 13.1036C4.166 18.0322 8.17488 22.0411 13.1035 22.0411C18.0321 22.0411 22.041 18.0322 22.041 13.1036C22.041 8.175 18.0321 4.16613 13.1035 4.16613Z",
    fill: "#1375ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.95887C12.402 5.95887 11.9161 5.473 11.9161 4.875V1.08387C11.9161 0.48425 12.402 0 13 0C13.598 0 14.0839 0.485875 14.0839 1.08387V4.875C14.0839 5.473 13.598 5.95887 13 5.95887Z",
    fill: "#1375ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9161 14.0839H21.125C20.527 14.0839 20.0411 13.598 20.0411 13C20.0411 12.402 20.527 11.9161 21.125 11.9161H24.9161C25.5158 11.9161 26 12.402 26 13C26 13.598 25.5158 14.0839 24.9161 14.0839Z",
    fill: "#1375ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 26C12.402 26 11.9161 25.5141 11.9161 24.9161V21.125C11.9161 20.527 12.402 20.0411 13 20.0411C13.598 20.0411 14.0839 20.527 14.0839 21.125V24.9161C14.0839 25.5158 13.598 26 13 26Z",
    fill: "#1375ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 14.0839H1.08387C0.48425 14.0839 0 13.598 0 13C0 12.402 0.485875 11.9161 1.08387 11.9161H4.875C5.473 11.9161 5.95887 12.402 5.95887 13C5.95887 13.598 5.473 14.0839 4.875 14.0839Z",
    fill: "#1375ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2501 16.5C11.4577 16.5 10.0001 15.0424 10.0001 13.25C10.0001 11.4576 11.4577 10 13.2501 10C15.0424 10 16.5001 11.4576 16.5001 13.25C16.5001 15.0424 15.0424 16.5 13.2501 16.5ZM13.2501 12.1661C12.6521 12.1661 12.1662 12.652 12.1662 13.25C12.1662 13.848 12.6521 14.3339 13.2501 14.3339C13.8481 14.3339 14.3339 13.848 14.3339 13.25C14.3339 12.652 13.8481 12.1661 13.2501 12.1661Z",
    fill: "#1375ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTarget);
export default __webpack_public_path__ + "static/media/icon_target.807620c83f3e63455fefe64f271091c8.svg";
export { ForwardRef as ReactComponent };